<template>
  <BaseBarLine :name='name' :getDataAction='getDataAction' :leftName='leftName' :rightName='rightName' :isShowCloseBtn='isShowCloseBtn' @SizeChange='sizeChange' @StateChange='stateChange'></BaseBarLine>
</template>

<script>
import {
  GetPurchaseComparisonBySixMonths
} from '@/api'
import BaseBarLine from './../baseBarLine.vue'
export default ({
  components: {
    BaseBarLine
  },
  data () {
    return {
      getDataAction: GetPurchaseComparisonBySixMonths,
      leftName: '金额（万元）',
      rightName: '数量'
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  //监听beforinfo值的变化
  watch: {
  },
  methods: {
    sizeChange (a, b, c, d) {
      this.$emit('SizeChange', a, b, c, d)
    },
    stateChange (a, b) {
      this.$emit('StateChange', a, b)
    },
  },


  mounted () {

    // this.init()
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    // this.getData();
  },
})
</script>
<style scoped lang="scss">
</style>
